import * as React from 'react';
export const WSSvg = React.forwardRef(function WSSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M2 2h7v7H0V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M5 5.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm-1 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm-.933-3.75a.5.5 0 1 1 .866-.5.5.5 0 0 1-.866.5ZM2 5.5c0-.276.22-.5.49-.5a.489.489 0 0 1 .441.245.508.508 0 0 1 0 .51.489.489 0 0 1-.44.245A.495.495 0 0 1 2 5.5Z',
      }),
    ),
  );
});
WSSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var WS = {
  category: 'flag',
  colorable: false,
  name: 'WS',
  svg: WSSvg,
};
